import React from "react";
import { Link } from "react-router-dom";
import "./styledLink.scss";

const StyledLink = ({
  styles,
  to,
  linkName,
  leftIcon,
  rightIcon,
  linkColor,
  fontSize,
  fontWeight,
  leftIconColor,
  rightIconColor,
  backColorLink,
  leftIconSize,
  rightIconSize,
  flexDirection,
  alignItems,
}) => {
  return (
    <div className="styledLink">
      {/* <div className="hover"></div> */}
      <Link
        to={to}
        className={`styledLink ${styles}`}
        style={{
          backgroundColor: `${backColorLink}`,
          flexDirection: `${flexDirection}`,
          alignItems: `${alignItems}`,
        }}
      >
        {leftIcon ? (
          <div
            className="icon"
            style={{ color: `${leftIconColor}`, fontSize: `${leftIconSize}` }}
          >
            {leftIcon}
          </div>
        ) : null}

        <p
          style={{
            fontWeight: `${fontWeight}`,
            fontSize: `${fontSize}`,
            color: `${linkColor}`,
          }}
        >
          {linkName}
        </p>

        {rightIcon ? (
          <div
            className="icon"
            style={{ color: `${rightIconColor}`, fontSize: `${rightIconSize}` }}
          >
            {rightIcon}
          </div>
        ) : null}
      </Link>
    </div>
  );
};

export default StyledLink;
